import CssBaseline from '@mui/material/CssBaseline';
import { Buffer } from 'buffer';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './locales';

window.Buffer = window.Buffer || Buffer;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <>
        <CssBaseline />
        <App />
    </>
);
